






















































import { defineComponent, computed } from '@nuxtjs/composition-api';
import { addCurrency, priceFormat } from '~/helpers/utils';
import useUrlFormatter from '~/hooks/useUrlFormatter';

export default defineComponent({
  name: 'CartItem',
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  setup(props) {
    const formatUrl = useUrlFormatter();

    const computedUrl = computed(() =>
      props.item.url === '/' ? '/' : formatUrl(props.item.url)
    );

    return {
      priceFormat,
      addCurrency,
      formatUrl,
      computedUrl
    };
  }
});
